export default "__VITE_ASSET__DlXbDUqw__"